var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gif)?_c('div',{staticClass:"scrible-wrapper"},[_c('img',{staticClass:"img",style:({width: (_vm.width + "%"), margin: _vm.margin}),attrs:{"src":_vm.gif.url,"alt":""},on:{"click":function($event){return _vm.handleAction()}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }